'use client';

import CheckmarkCircle from '@crehana/compass.icons.fill/CheckmarkCircle';
import Clipboard from '@crehana/compass.icons.outline/Clipboard';
import Inbox from '@crehana/compass.icons.outline/Inbox';
import clsx from 'clsx';

type TApplicationFormStatusProps = {
  title: string;
  subtitle?: string;
  description: string;
  type: 'success' | 'close' | 'not-found';
};

export const ApplicationFormStatus: React.FC<TApplicationFormStatusProps> = ({
  title,
  subtitle,
  description,
  type,
}) => {
  return (
    <div
      className="tw-h-full tw-flex tw-items-center tw-bg-neutral-light-100 tw-rounded-0.8 tw-border tw-border-solid tw-border-neutral-light-400 tw-w-full"
      style={{
        ...(type === 'success' && {
          background:
            'radial-gradient(32.49% 32.49% at 92.25% 76.95%, rgba(184, 252, 218, 0.40) 0%, rgba(255, 255, 255, 0.40) 100%), #FFF',
        }),
        ...(type === 'close' && {
          background:
            'radial-gradient(57.16% 28.68% at 92.4% 86.13%, rgba(146, 146, 146, 0.40) 0%, rgba(255, 255, 255, 0.40) 100%), #FFF',
        }),
        ...(type === 'not-found' && {
          background:
            'radial-gradient(57.16% 28.68% at 92.4% 86.13%, rgba(218, 67, 94, 0.40) 0%, rgba(255, 255, 255, 0.40) 100%), #FFF',
        }),
      }}
    >
      <div className="tw-flex tw-flex-col tw-w-full tw-justify-center tw-items-center tw-text-center">
        {type === 'success' && (
          <div className="tw-w-7.2 tw-h-7.2 tw-bg-success-100 tw-rounded-full tw-flex tw-justify-center tw-items-center">
            <CheckmarkCircle size={65} className="tw-text-success-400" />
          </div>
        )}
        {type === 'close' && (
          <div className="tw-w-7.2 tw-h-7.2 tw-bg-neutral-light-300 tw-rounded-full tw-flex tw-justify-center tw-items-center">
            <Clipboard size={48} className="tw-text-neutral-light-700" />
          </div>
        )}
        {type === 'not-found' && (
          <div className="tw-w-7.2 tw-h-7.2 tw-bg-alert-100 tw-rounded-full tw-flex tw-justify-center tw-items-center">
            <div className="tw-w-5.6 tw-h-5.6 tw-bg-alert-200 tw-rounded-full tw-flex tw-justify-center tw-items-center">
              <Inbox size={48} className="tw-text-alert-400" />
            </div>
          </div>
        )}

        <h3
          className={clsx(
            'tw-font-h3 tw-font-semibold tw-mt-4 tw-mb-2.4',
            type === 'success' && 'tw-text-success-600',
            type === 'close' && 'tw-text-neutral-light-800',
            type === 'not-found' && 'tw-text-alert-600',
          )}
        >
          {title}
        </h3>
        {subtitle && (
          <p className="tw-font-body1 tw-text-neutral-light-700">{subtitle}</p>
        )}
        <p className="tw-font-body1 tw-text-neutral-light-700">{description}</p>
      </div>
    </div>
  );
};
